import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import type PostLoginService from 'tio-employee/services/post-login';

export default class PostLoginMfaSmsRoute extends Route {
  @service declare postLogin: PostLoginService;
  @service declare router: RouterService;

  beforeModel() {
    this.postLogin.initializeFromSession();
    if (!this.postLogin.tempToken) {
      return this.router.transitionTo('login');
    }
  }

  async afterModel() {
    await this.postLogin.ensureMfaCodeSent();
  }
}
